import { render, staticRenderFns } from "./CustomFieldRenderer.vue?vue&type=template&id=ca3baef0"
import script from "./CustomFieldRenderer.vue?vue&type=script&lang=js"
export * from "./CustomFieldRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports